import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../../Box/Box.js';
import { pricePartsToString } from '../PriceHelper.js';
import { Typography } from '../../Typography/Typography.js';
import { Direction, useDirectionContext } from '../../../contexts/session/Locale.js';

var _excluded = ["price", "isMatchCurrencySize", "variant", "size"];
var primaryTypography = {
  s: 'body-s',
  m: 'body-default-strong',
  l: 'heading-l'
};
var secondaryTypography = {
  s: 'caption-default',
  m: 'caption-default-strong',
  l: 'caption-default-strong'
};
var getCurrencySpacing = function getCurrencySpacing(direction, alignCurrency) {
  if (direction === Direction.LTR) {
    return alignCurrency === 'end' ? {
      ms: '4'
    } : {
      me: '4'
    };
  }
  return alignCurrency === 'end' ? {
    me: '4'
  } : {
    ms: '4'
  };
};
var FinalRate = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var price = _ref.price,
    _ref$isMatchCurrencyS = _ref.isMatchCurrencySize,
    isMatchCurrencySize = _ref$isMatchCurrencyS === void 0 ? false : _ref$isMatchCurrencyS,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'product.price' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var direction = useDirectionContext();
  var finalRatePrice = Array.isArray(price) ? pricePartsToString(price) : price;
  var currencySpacing = getCurrencySpacing(direction, finalRatePrice.alignCurrency);
  var currencySize = isMatchCurrencySize ? primaryTypography[size] : secondaryTypography[size];
  var currencyElement = /*#__PURE__*/React.createElement(Typography, _extends({
    tag: "span",
    textColor: variant,
    variant: currencySize
  }, currencySpacing), finalRatePrice.currency);
  return /*#__PURE__*/React.createElement(Box, _extends({
    dir: "ltr" // Do not flip currency for final rate
    ,
    display: "inline-flex",
    alignItems: "baseline",
    flexDirection: "row"
  }, rest, {
    ref: ref
  }), finalRatePrice.alignCurrency !== 'end' && currencyElement, /*#__PURE__*/React.createElement(Typography, {
    tag: "span",
    variant: primaryTypography[size],
    textColor: variant
  }, finalRatePrice.amount), finalRatePrice.alignCurrency === 'end' && currencyElement);
});
FinalRate.defaultProps = {
  size: 'l'
};
var FinalRateMemoized = /*#__PURE__*/React.memo(FinalRate);
FinalRateMemoized.displayName = 'FinalRate';

export { FinalRateMemoized as FinalRate };
//# sourceMappingURL=FinalRate.js.map
